import React from "react";
import wrapperHOC from "@Utils/wrapperHOC";

type ReviewUserDetailsProps = {
  userName?: string;
  email?: string;
  phoneNumber?: string;
};

const avatarStyle: React.CSSProperties = {
  width: 48,
  height: 48,
  borderRadius: "50%",
  backgroundColor: "#e3f2fd",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 18,
  fontWeight: 600,
  color: "#333",
  marginRight: 12,
  border: "1px solid #e0e0e0",
};

const userInfoStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 4,
};

const nameStyle: React.CSSProperties = {
  fontSize: 16,
  fontWeight: 600,
  color: "#333",
};

const detailStyle: React.CSSProperties = {
  fontSize: 14,
  color: "#333",
  fontWeight: 400,
};

const containerStyle: React.CSSProperties = {
  background: "transparent",
  border: "none",
  borderRadius: 0,
  padding: 0,
  marginBottom: 16,
};

const titleStyle: React.CSSProperties = {
  fontSize: 16,
  fontWeight: 500,
  marginBottom: 12,
  color: "#111928",
  lineHeight: "21px",
};

const userSectionStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
};

// Mobile-specific styles
const mobileContainerStyle: React.CSSProperties = {
  background: "transparent",
  border: "none",
  borderRadius: 0,
  padding: 0,
  marginBottom: 24,
};

const mobileTitleStyle: React.CSSProperties = {
  fontSize: 16,
  fontWeight: 600,
  marginBottom: 16,
  color: "#111928",
  lineHeight: "21px",
};

const ReviewUserDetails = ({ userName, email, phoneNumber }: ReviewUserDetailsProps) => {
  const getInitial = (name: string) => (name ? name.charAt(0).toUpperCase() : "A");

  // Check if mobile screen
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

  return (
    <div style={isMobile ? mobileContainerStyle : containerStyle}>
      <div style={isMobile ? mobileTitleStyle : titleStyle}>Your booking details</div>
      <div style={userSectionStyle}>
        <div style={avatarStyle}>{getInitial(userName || "A")}</div>
        <div style={userInfoStyle}>
          {userName && <div style={nameStyle}>{userName}</div>}
          {email && <div style={detailStyle}>{email}</div>}
          {phoneNumber && <div style={detailStyle}>{phoneNumber}</div>}
        </div>
      </div>
    </div>
  );
};

export default wrapperHOC(ReviewUserDetails, {
  componentName: "ReviewUserDetails-UserReviewScreen",
  showForChina: true,
});
